import React, { createContext, useContext } from 'react'
import { trustMarkerEntryId } from '../trustMarkerEntryFields'

export const TrustMarkersContext = createContext({})

export const TrustMarkersProvider = React.memo(
  ({ children, trustMarkers = [] }) => {
    const getAllTrustMarkers = () => trustMarkers
    const getTrustMarkerById = (id) =>
      trustMarkers.find(
        (trustMarker) =>
          trustMarkerEntryId(trustMarker)?.toLowerCase() === id?.toLowerCase()
      )

    return (
      <TrustMarkersContext.Provider
        value={{ getAllTrustMarkers, getTrustMarkerById }}
      >
        {children}
      </TrustMarkersContext.Provider>
    )
  }
)

export const useTrustMarkers = () => useContext(TrustMarkersContext)

TrustMarkersProvider.displayName = 'TrustMarkersProvider'
